<template>
    <div>
        <!-- Modal para visualizar informações do cliente -->
        <div class="modal fade" id="mdinformacoescliente" tabindex="-1" aria-labelledby="mdlinformacoescliente" aria-hidden="true" style="z-index: 1050;">
			<div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header" style="">
						<h5 class="modal-title" id="mdlinformacoesclientecliente"><i class="fa fa-info-circle"></i> Informações do cliente</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
                    <!-- Dados do cliente -->
					<div class="modal-header" style="background: white; border-bottom: 1px solid #dee2e6; padding-bottom: 15px;">
                        <div class="container-fluid">
                            <div class="row" style="padding-top: 15px;">
                                <div class="col-md-10" style="padding-bottom: 15px;">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                            <label for="edclienteinf">Cliente:</label>
                                            <input type="text" class="form-control form-control-sm text-uppercase font-weight-bold" id="edclienteinf" v-bind:value="id+' - '+nomecliente"
                                                data-bv-group=".group" disabled/>
                                        </div>
                                        <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                                            <label for="edvlcreditoinf">Crédito:</label>
                                            <input type="text" class="form-control form-control-sm text-right font-weight-bold text-success" id="edvlcreditoinf" v-bind:value="mtdformatavalordecimal(vlcredito, 2)"
                                                data-bv-group=".group" disabled/>
                                        </div>
                                        <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                                            <label for="edvlcreditoutilizadoinf">Utilizado:</label>
                                            <input type="text" class="form-control form-control-sm text-right font-weight-bold text-warning" id="edvlcreditoutilizadoinf" v-bind:value="mtdformatavalordecimal(vrTotal, 2)"
                                                data-bv-group=".group" disabled/>
                                        </div>
                                        <div class="col-sm-12 col-md-2 col-lg-6 col-xl-2">
                                            <label for="edvlcreditodisponivelinf">Disponível:</label>
                                            <input type="text" v-bind:class="parseFloat(vlcredito) - parseFloat(vrTotal) > 0 ? 'text-success' : 'text-danger'" class="form-control form-control-sm text-right font-weight-bold" id="edvlcreditodisponivelinf" v-bind:value="mtdformatavalordecimal(parseFloat(vlcredito) - parseFloat(vrTotal), 2)"
                                                data-bv-group=".group" disabled/>
                                        </div>
                                        <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                                            <label for="eddtultcompra">Ultima compra:</label>
                                            <input type="text" class="form-control form-control-sm text-right font-weight-bold text-warning" id="eddtultcompra" v-bind:value="vdtultimacompra"
                                                data-bv-group=".group" disabled/>
                                        </div>
                                        <div class="col-sm-4 col-md-4 col-lg-4">
                                            <label for="cboplistagem">Listar:</label>
                                            <select name="cboplistagem" class="form-control form-control-sm" id="cbSituacao" v-model="oplistagem" @change.prevent="mtdlistagem()">
                                                <option value="0">Títulos em aberto</option>
                                                <option value="1">Títulos pagos</option>
                                                <option value="2">Pedidos faturados</option>
                                                <option value="3">Notas Emitidas</option>
                                            </select>
                                        </div> 
                                    </div>
                                </div>
                                <div class="col-md-2 text-center">
                                    <img class="img-cliente-inf" title="imagem do cliente" v-bind:src="imagemcliente"> 
                                </div>
                            </div>                            
                        </div>                        
					</div>                    
					<div class="modal-body" style="padding-bottom: 0px; padding-left: 0px; padding-right: 0px; ">
                        <!-- Títulos em aberto -->
                        <div class="container-fluid" v-show="(mostrar && parseInt(oplistagem) === 0)">
                            <div class="row">
                                <div class="col-lg-12" v-if="lsttitulos.length > 0">
                                    <div class="table-responsive">
                                        <table id="tblistatitrec" class="table table-bordered table-sm table-hover">
                                            <thead class="thead-dark">
                                            <tr>
                                                <th width="150">Nr. Título:</th>
                                                <th width="150">Cobrança:</th>
                                                <th width="150">Auxiliar:</th>
                                                <th width="100">Emissão:</th>
                                                <th width="100">Vencimento:</th>
                                                <th width="100">Vl. Título:</th>
                                                <th width="100">Restante:</th>
                                                <th width="60">Atraso:</th>     
                                                <th width="100">Juros:</th>
                                                <th width="100">Multa:</th>
                                                <th width="150">À receber:</th>                                                
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(titulo, index) in lsttitulos" v-bind:key="index" style="font-size: 12px;">
                                                    <td>{{titulo.codtit}}</td>
                                                    <td>{{titulo.desccob}}</td>
                                                    <td>{{titulo.codauxiliar}}</td>
                                                    <td style="text-align: right;">{{titulo.dtemitit}}</td>
                                                    <td style="text-align: right;">{{titulo.dtventit}}</td>
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vltit), 2)}}</td>
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vlresta), 2)}}</td>
                                                    <td class="text-center">
                                                        <span v-if="parseInt(titulo.atraso) > 0" class="badge badge-pill badge-danger">{{ titulo.atraso }}</span>
                                                        <span v-else></span>
                                                    </td>
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vljuros), 2)}}</td>
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vlmulta), 2)}}</td>                                                    
                                                    <td style="text-align: right; font-weight: bold;">{{mtdformatavalordecimal(parseFloat(titulo.vlapagar), 2)}}</td>
                                                </tr>
                                            </tbody>                                        
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-12" v-else>
                                    <hr>
                                    <div style="text-align: center;">
                                        <span style="font-size: larger;">Nenhum registro encontrado para sua busca. <i class="fa fa-search" aria-hidden="true"></i></span>
                                    </div>
                                </div>                                                                         
                            </div>
                        </div>
                        <!-- Títulos pagos -->
                        <div class="container-fluid" v-show="(mostrar && parseInt(oplistagem) === 1)">
                            <div class="row">
                                <div class="col-lg-12" v-if="lsttitulospagos.length > 0">
                                    <div class="table-responsive">
                                        <table id="tblistatitpag" class="table table-bordered table-sm table-hover">
                                            <thead class="thead-dark">
                                            <tr>
                                                <th width="150">Nr. Título:</th>
                                                <th width="150">Cobrança:</th>
                                                <th width="150">Auxiliar:</th>
                                                <th width="100">Emissão:</th>
                                                <th width="100">Vencimento:</th>
                                                <th width="100">Pagamento:</th>
                                                <th width="60">Atraso:</th>
                                                <th width="100">Vl. Título:</th>                                                  
                                                <th width="100">Juros:</th>
                                                <th width="100">Multa:</th>
                                                <th width="100">Descto(J/M):</th>
                                                <th width="150">Total pago:</th>                                                
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(titulo, index) in lsttitulospagos" v-bind:key="index" style="font-size: 12px;">
                                                    <td>{{titulo.codtit}}</td>
                                                    <td>{{titulo.desccob}}</td>
                                                    <td>{{titulo.codauxiliar}}</td>
                                                    <td style="text-align: right;">{{titulo.dtemitit}}</td>
                                                    <td style="text-align: right;">{{titulo.dtventit}}</td>
                                                    <td style="text-align: right; font-weight: bold;" class="text-success">{{titulo.dtpagtit}}</td>
                                                    <td class="text-center">
                                                        <span v-if="parseInt(titulo.atraso) > 0" class="badge badge-pill badge-danger">{{ titulo.atraso }}</span>
                                                        <span v-else></span>
                                                    </td>                                                    
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vlresta), 2)}}</td>
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vljuros), 2)}}</td>
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vlmulta), 2)}}</td>                                                    
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.valordescontojurosmulta), 2)}}</td>
                                                    <td style="text-align: right; font-weight: bold;">{{mtdformatavalordecimal(parseFloat(titulo.vlpagtit) + parseFloat(titulo.vljuros) + parseFloat(titulo.vlmulta), 2)}}</td>
                                                </tr>
                                            </tbody>                                        
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-12" v-else>
                                    <hr>
                                    <div style="text-align: center;">
                                        <span style="font-size: larger;">Nenhum registro encontrado para sua busca. <i class="fa fa-search" aria-hidden="true"></i></span>
                                    </div>
                                </div>                                                                          
                            </div>
                        </div> 
                        <!-- Pedidos do cliente -->
                        <div class="container-fluid" v-show="(mostrar && parseInt(oplistagem) === 2)" style="min-height: 300px;">
                            <div class="row" style="margin-top: -10px;">
                                <div class="col-md-3">
                                    <label for="eddtini">De:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtiniinf" v-model="dtiniinf" :config="options" class="form-control form-control-sm bottom"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>								
                                    </div>                        
                                </div>
                                <div class="col-md-3">
                                    <label for="eddtfiminf">até:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtfiminf" v-model="dtfiminf" :config="options" class="form-control form-control-sm"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>																			
                                    </div>                        
                                </div>
                                <div class="col-md-3">
                                    <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdlistagem()" style="margin-top: 20px;"><i class="fa fa-search"></i> Pesquisar</button>
                                </div>
                            </div>
                            <div class="row" style="margin-top: 10px;">
                                <div class="col-lg-12" v-if="lstpedidos.length > 0">
                                    <div class="table-responsive">
                                        <table id="tblistatbped" class="table table-bordered table-sm table-hover">
                                            <thead class="thead-dark">
                                            <tr>
                                                <th width="30"></th>
                                                <th width="20"></th>
                                                <th>Nr. Pedido:</th>
                                                <th>Dt. fatura:</th>                                                
                                                <th>Vendedor:</th>
                                                <th>Plano:</th>
                                                <th>Rota:</th>
                                                <th>Total:</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(pedido, index) in lstpedidos">
                                                    <tr v-bind:key="index" style="font-size: 12px;">
                                                        <td class="text-center">
                                                            <span v-if="parseFloat(pedido.conferido) === 0" style="font-size: 20px; cursor: pointer;" @click.prevent="mtdexpandirpedidos(index)"><i class="fa fa-chevron-circle-down text-primary"></i></span>
                                                            <span v-else style="font-size: 20px; cursor: pointer;"><i class="fa fa-chevron-circle-up text-primary" @click.prevent="mtdexpandirpedidos(index)"></i></span>													
                                                        </td>
                                                        <td class="text-center">
                                                            <div class="custom-control custom-checkbox">
                                                                <input type="checkbox" class="custom-control-input" :id="'customCheck' + pedido.id" v-model="lstpedidosselecionados" :value="pedido">
                                                                <label class="custom-control-label" :for="'customCheck'+ pedido.id"></label>
                                                            </div>
                                                        </td>                                                        
                                                        <td style="width: 90px; font-weight: bold;">{{mtdformatarzeros(pedido.id, 8)}}</td>
                                                        <td style="width: 140px;">{{pedido.dtfatura}}</td>                                                        
                                                        <td style="width: 180px;">{{pedido.nomevendedor}}</td>
                                                        <td style="width: 180px;">{{pedido.descplano}}</td>
                                                        <td style="width: 180px;">{{pedido.descrota}}</td>
                                                        <td style="width: 120px; text-align: right; font-weight: bold;">{{mtdformatavalordecimal(parseFloat(pedido.totalgeral), 2)}}</td>
                                                    </tr>
                                                    <tr v-bind:key="index">
                                                        <td colspan="7" v-show="parseInt(pedido.conferido) === 1" style="padding-left: 35px; padding-right: 35px;">
                                                            <table id="tbclista" class="table table-bordered table-sm table-hover" style="margin-top: 2px; margin-bottom: 2px;">
                                                                <thead class="thead-light">
                                                                    <tr>
                                                                        <th width="30">Item:</th>
                                                                        <th width="100">Codigo:</th>
                                                                        <th width="300">Descrição:</th>
                                                                        <th width="100">Referência:</th>
                                                                        <th width="40">Und:</th>
                                                                        <th width="40">Marca:</th>
                                                                        <th width="100">Vl. Unitário:</th>
                                                                        <th width="50">Qtd:</th>     
                                                                        <th width="100">Vl. Descto:</th>
                                                                        <th width="100">Vl. Total:</th>
                                                                        <th width="100">Local.:</th>
                                                                        <th width="100">Estoque:</th> 										
                                                                    </tr>																								
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item, indexi) in pedido.itens" style="font-size: 12px;" :key="indexi">
                                                                        <td class="text-center">{{item.item}}</td>
                                                                        <td>{{item.coddig}}</td>
                                                                        <td>{{item.descproduto}}</td>
                                                                        <td>{{item.referencia}}</td>
                                                                        <td>{{item.unditem}}</td>
                                                                        <td>{{item.descmarca}}</td>
                                                                        <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlunitario), 2)}}</td>
                                                                        <td style="text-align: right;">{{item.qtditem}}</td>
                                                                        <template v-if="parseInt(item.descacres) === 0">
                                                                            <td v-if="parseInt(item.tipodescacres) === 0" style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlunitario) * parseFloat(item.qtditem) * parseFloat(item.valordescacres) / 100 , 2)}}</td>                                                
                                                                            <td v-else style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.valordescacres), 2)}}</td>                                                
                                                                        </template>
                                                                        <template v-else>
                                                                            <td></td>
                                                                        </template>
                                                                        <td style="text-align: right; font-weight: 500;">
                                                                            <i v-show="parseFloat(item.vltotalimposto) > 0" class="fa fa-info-circle text-black-50" v-bind:title="'Imposto do item: R$ '+ mtdformatavalordecimal(parseFloat(item.vltotalimposto), 2)" style="font-size: 18px; float: left;"></i>
                                                                            {{mtdformatavalordecimal(parseFloat(item.vltotal), 2)}}
                                                                        </td>
                                                                        <td>{{item.localizacao}}</td>
                                                                        <td>{{item.descestoque}}</td>
                                                                    </tr>	
                                                                </tbody>
                                                            </table>													
                                                        </td>
                                                    </tr>                                                    
                                                </template>
                                            </tbody>                                        
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-12" v-else>
                                    <hr>
                                    <div style="text-align: center;">
                                        <span style="font-size: larger;">Nenhum registro encontrado para sua busca. <i class="fa fa-search" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>                       
                        <!-- Notas emitidas do cliente -->
                        <div class="container-fluid" v-show="(mostrar && parseInt(oplistagem) === 3)" style="min-height: 300px;">
                            <div class="row" style="margin-top: -10px;">
                                <div class="col-md-3">
                                    <label for="eddtini">De:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtini" v-model="dtiniemissaont" :config="options" class="form-control form-control-sm"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>								
                                    </div>                        
                                </div>
                                <div class="col-md-3">
                                    <label for="eddtfim">até:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtfim" v-model="dtfimemissaont" :config="options" class="form-control form-control-sm"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>																			
                                    </div>                        
                                </div>
                                <div class="col-md-3">
                                    <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdlistagem()" style="margin-top: 20px;"><i class="fa fa-search"></i> Pesquisar</button>
                                </div>
                            </div>
                            <div class="row" style="margin-top: 10px;">
                                <div class="col-lg-12" v-if="lstnotasemitidas.length >  0">
                                    <div class="table-responsive">
                                        <table id="tblistanotasemitidas" class="table table-bordered table-sm table-hover">
                                            <thead class="thead-dark">
                                            <tr>
                                                <th>#</th>
                                                <th>Filial:</th>
                                                <th>Nr. Nota:</th>                                                
                                                <th>Situação:</th>
                                                <th>Modelo:</th>
                                                <th>Série:</th>
                                                <th>Emissão:</th>
                                                <th>Destinatário:</th>
                                                <th>Natureza operação:</th>
                                                <th>Valor:</th>
                                                <th>Retorno sefaz:</th>
                                                <th>Chave:</th>                                                
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(notaemitida, index) in lstnotasemitidas" v-bind:key="index" style="font-size: 12px;">
                                                    <td>
                                                        <div class="custom-control custom-checkbox">
                                                            <input type="checkbox" class="custom-control-input" :id="'customCheck' + notaemitida.nnf" v-model="lstnotasselecionadas" :value="notaemitida">
                                                            <label class="custom-control-label" :for="'customCheck'+ notaemitida.nnf"></label>
                                                        </div>
                                                    </td>
                                                    <td>{{notaemitida.fantasiafil}}</td>
                                                    <td>{{mtdformatarzeros(notaemitida.nnf, 8)}}</td>
                                                    <td style="text-align: center;">
                                                        <span class="badge badge-primary bdg-autorizada" >Autorizadas</span></td>
                                                    <td style="text-align: center;">{{notaemitida.modelo}}</td>
                                                    <td style="text-align: center;">{{mtdformatarzeros(notaemitida.serie, 3)}}</td>
                                                    <td>{{notaemitida.dthremissao}}</td>
                                                    <td>{{notaemitida.nomedestinatario}}</td>
                                                    <td>{{notaemitida.descnatop}}</td>
                                                    <td style="text-align: end;">{{mtdformatavalordecimal(notaemitida.vnf, 2)}}</td>
                                                    <td>{{notaemitida.xmotivo}}</td>
                                                    <td>{{notaemitida.chave}}</td>
                                                </tr>
                                            </tbody>                                        
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-12" v-else>
                                    <hr>
                                    <div style="text-align: center;">
                                        <span style="font-size: larger;">Nenhum registro encontrado para sua busca. <i class="fa fa-search" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>                       
					</div>
                    <div class="modal-footer">                        
                        <div class="container-fluid">
                            <!-- totais dos títulos em aberto -->
                            <div class="row" v-show="mostrar && parseInt(oplistagem) === 0">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-body" style="padding: 15px;">
                                            <div class="row justify-content-center">
                                                <div class="col-sm-12 col-md-6 col-lg-6">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec">Vencidos <span class="badge badge-danger bdgtitulos">{{ mtdformatavalordecimal(vrVencidos, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Juros <span class="badge badge-warning bdgtitulos">{{ mtdformatavalordecimal(vrJuros, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Títulos <span class="badge badge-info bdgtitulos">{{ lsttitulos.length }}</span></a>
                                                    </ul>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec">A vencer <span class="badge badge-primary bdgtitulos">{{ mtdformatavalordecimal(vrAvencer, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vrMulta, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Total geral <span class="badge badge-success bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(vrTotal, 2) }}</span>
                                                        </a>
                                                    </ul>
                                                </div>                                   
                                            </div>
                                        </div>
                                    </div>
                                </div>                 
                            </div>
                            <!-- totais dos títulos baixados -->  
                            <div class="row" v-show="(mostrar && parseInt(oplistagem) === 1)">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-body" style="padding: 15px;">
                                            <div class="row justify-content-center">
                                                <div class="col-sm-12 col-md-6 col-lg-6">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec">Total juros <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotaljuros, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Total descontos <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotaldescontos, 2) }}</span></a>
                                                    </ul>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6" id="dvselecionados">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec">Total multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotalmulta, 2) }}</span></a>                                                    
                                                        <a class="list-group-item lstdetrec">Total recebido <span class="badge badge-info" style="font-size: 12px;">{{ lsttitulospagos.length }}</span>
                                                            <span class="badge badge-warning bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(vtotgeral, 2) }}</span>
                                                        </a>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>                                                                
                            <!-- Total dos pedidos -->
                            <div class="row" v-show="(mostrar && parseInt(oplistagem) === 2)">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-body" style="padding: 15px;">
                                            <div class="row justify-content-center">
                                                <div class="col-sm-12 col-md-6 col-lg-6">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec">Pedidos <span class="badge badge-info bdgtitulos">{{ lstpedidos.length }}</span></a>
                                                    </ul>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6" id="dvselecionados">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec">Total faturado 
                                                            <span class="badge badge-warning bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(totalfaturado, 2) }}</span>
                                                        </a>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                            <!-- Total dos notas fiscais -->
                            <div class="row" v-show="(mostrar && parseInt(oplistagem) === 3)">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-body" style="padding: 15px;">
                                            <div class="row justify-content-center mb-2">
                                                <div class="col-sm-12 col-md-12 col-lg-12">
                                                    <ul class="list-group">
                                                        <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                                        <span>Totalizadores <span class="badge badge-info badge-pill">{{lstnotasemitidas.length}}</span></span>
                                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="background-color: #5A956A;">{{mtdformatavalordecimal(parseFloat(ptotalnotas), 2)}}</span>
                                                    </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="row justify-content-center">
                                                <div class="col-sm-12 col-md-8 col-lg-8">
                                                    <ul class="list-group">
                                                        <a class="list-group-item text-center tit-list-group-item font-weight-bold text-black-50" style="color: #cccccc!important; background-color: #343a40; padding: 5px;">DEMONSTRATIVO CFOP'S</a>
                                                        <a v-for="(cfop, indice) in lstdemonstrativoscfop" class="list-group-item ">{{ cfop.idcfop }} 
                                                            <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(cfop.vltotal) }}</span>
                                                        </a>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                            <div class="row" style="margin-top: 15px;">
                                <div class="col-10 p-0" style="display: flex; justify-content: end;">
                                    <!-- Envia notas para email -->
                                    <div class="col-2 p-0" v-show="(mostrar && parseInt(oplistagem) === 3)">
                                        <button type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mdlexportxml()">
                                            <i class="fa fa-download"></i> Salvar xml
                                        </button>
                                    </div>                                
                                    <!-- imprimi pedidos -->
                                    <div class="col-2 p-0" v-show="(mostrar && parseInt(oplistagem) === 2)">
                                        <button type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdimpressao()">
                                            <i class="fa fa-download"></i> Imprimir
                                        </button>
                                    </div>                                
                                </div>
                                <div class="col-2 text-right" >
                                    <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-sign-out"></i> Sair</button>
                                </div>                                
                            </div>
                        </div>
                    </div>

                    <!-- Modal para configurar exportação xml --> 
                    <div class="modal fade show" id="mdexportxml" tabindex="-1">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">                        
                                <div class="modal-header">
                                    <i class="fa fa-file-archive-o" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Exportar notas</h4>
                                    <button type="button" @click.prevent="mtdfechamdlxml()" style="background-color: transparent; border: 0; height: 15px; color: white;">&times;</button>
                                </div>                
                                <div class="modal-body">
                                    <div style="padding-top: 20px;" class="row">  
                                        <div class="col-12">
                                            <label for="edemail"> E-mail destinatário:</label>
                                            <input type="email" v-model="vemailxml" 
                                                class="form-control form-control-sm" id="edemail" maxlength="100"
                                                style="text-transform: lowercase;">
                                        </div>
                                    </div>
                                </div>                                            
                                <div class="modal-footer">
                                    <button id="btconfirmar" type="button" @click.prevent="mtdsalvarxmls()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                                    <button type="button" class="btn btn-secondary btn-sm" @click.prevent="mtdfechamdlxml()"><i class="fa fa-close"></i> Cancelar</button>
                                </div>                          
                            </div>
                        </div>
                    </div>				
				</div>
			</div>
		</div>       
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
export default {
    name: 'cmpinformacoescliente',
    components:{
    },    
    props:[    
        'id',
        'nomecliente',
        'vlcredito',
        'imagemcliente'
        
    ],
    data: function() {
        return {
            mostrar         : false,
            oplistagem      : 0,
            //titulos em aberto
            lsttitulos      : [],
            vrVencidos      : 0,
            vrAvencer       : 0,
            vrJuros         : 0,
            vrMulta         : 0,
            vrTotal         : 0,
            //titulos pagos
            lsttitulospagos : [],
            vtotaldescontos : 0,
            vtotaljuros     : 0,
            vtotalmulta     : 0,
            vtotaltitulos   : 0,
            vtotgeral       : 0,
            vdtultimacompra : '',

            // notas emitidas
            lstnotasemitidas : [],
            dtiniemissaont   : util.DataAtual(true),
			dtfimemissaont   : util.DataAtual(true),
            lstdemonstrativoscfop : [],
            ptotalnotas      : 0,
            lstnotasselecionadas: [],

            //variaveis nova exportação xml
            pmodelo              : 99,
            pidfilial            : null,
            pfiltroperiodo       : 1,
            ptpemis              : 2,
            pidnatop             : null,
            ptpdestinatario      : 0,       
            anoslista           : [],
            anoAtual            : 0,
            anoselect           : 0,
            vespecificarperiodo : 0,
            vfenviados          : 0,
            messelect           : 0,  
            permiteenvioxml     : 0,

            // email xml 
            vemailxml           : '',
            venviaemail         : false,

            //filtros salvar xml
            pdtinixml       	: util.DataAtual(true),
            pdtfimxml           : util.DataAtual(true),
            pfiltroinutilizadas : '',


            //pedidos
            lstpedidos      : [],
            totalfaturado   : 0,
            lstpedidosselecionados: [],

            //detalhes do pedido
            vidpedidodet    : '',
            options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR',
            },
            dtiniinf       	: util.DataAtual(true),
			dtfiminf       	: util.DataAtual(true)
        };
    },
    methods: { 
        mtdpegadtultimacompracli(){
            let vself       = this;
            let loader      = vself.$loading.show();
         

            let filtro      = ' and c.id='+vself.id;
            let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'listagem'},                                        
                    {parametro: 'filtro',       valor  : filtro},
                    {parametro: 'limit',        valor  : '99999999999'},
                    {parametro: 'offset',       valor  : '0'}
                ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
            retorno.then(function (response) {
                vself.vdtultimacompra = response.data[0].dtultimacompra
                loader.hide();
            }).catch(function (response) {
                vself.lsttitulos = [];
                loader.hide();
            });
            
        },
        mtdformatavalordecimal(valor, digitos){
            if ($.isNumeric(valor)){
			    return util.formatavalordecimais(valor, digitos);
            }else{
                return '0,00';
            }
		},       
        mtdformatarzeros(str, length){
            return util.formatarzeros(str, length);
        },                       
        mtdlistagem(){
            let vself = this;
            let tplistagem = "";
            tplistagem = vself.oplistagem;
            switch (parseInt(tplistagem)) {
                case 0:
                    vself.mtdlistartitulosreceber();
                break;
                case 1:
                    vself.mtdlistartitulospagos();
                break;                
                case 2:
                    vself.mtdlistarpedidosfaturados();
                break;
                case 3:
                    vself.mtdlistarnotasemitidas();
                break;                 
            }
        },
        mtdlistartitulosreceber(){
            let vself       = this;
            let loader      = vself.$loading.show();

            vself.mostrar           = false;
            vself.lsttitulos        = [];
            //iguala totais dos titulos para calcular os selecionados
            vself.vrVencidos        = 0;
            vself.vrAvencer         = 0;
            vself.vrJuros           = 0;
            vself.vrMulta           = 0;
            vself.vrTotal           = 0;            

            let filtro      = ' and t.idcliente='+vself.id+' and t.inativo=0 and t.sttit in ("A", "P")';
            let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'listagem'},
                    {parametro: 'situacao',     valor  : 0},
                    {parametro: 'ordem',        valor  : 2}, 
                    {parametro: 'dtbasecalculo',valor  : util.InverterData(util.DataAtual(true))},                                                
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : '99999999999'},
                    {parametro: 'offset',       valor : '0'}
                ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
            retorno.then(function (response) {
                vself.mostrar     = true;
                vself.lsttitulos  = response.data.lista;
                //iguala totais dos titulos para calcular os selecionados
                vself.vrVencidos        = response.data.vencidos;
                vself.vrAvencer         = response.data.avencer;
                vself.vrJuros           = response.data.totjuros;
                vself.vrMulta           = response.data.totmulta;
                vself.vrTotal           = response.data.totgeral;
                loader.hide();
            }).catch(function (response) {
                vself.lsttitulos = [];
                loader.hide();
            });
        },
        mtdlistartitulospagos(){
            let vself       = this;
            let loader      = vself.$loading.show();
            vself.mostrar   = false;
            //iguala totais dos titulos para calcular os selecionados                
            vself.lsttitulospagos   = [];
            vself.lstpedidosselecionados = [];
            vself.vtotaldescontos   = 0;
            vself.vtotaljuros       = 0;
            vself.vtotalmulta       = 0;
            vself.vtotaltitulos     = 0;
            vself.vtotgeral         = 0; 
            let filtro      = ' and t.idcliente='+vself.id;
            let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'listagem'},
                    {parametro: 'situacao',     valor  : 1},
                    {parametro: 'ordem',        valor  : 2}, 
                    {parametro: 'dtbasecalculo',valor  : util.InverterData(util.DataAtual(true))},                                                
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : '99999999999'},
                    {parametro: 'offset',       valor : '0'}
                ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
            retorno.then(function (response) {
                vself.mostrar     = true;
                //iguala totais dos titulos para calcular os selecionados                
                vself.lsttitulospagos   = response.data.lista;
                vself.vtotaldescontos   = response.data.totaldescontos;
                vself.vtotaljuros       = response.data.totaljuros;
                vself.vtotalmulta       = response.data.totalmulta;
                vself.vtotaltitulos     = response.data.totaltitulos;
                vself.vtotgeral         = response.data.totgeral; 
                loader.hide();
            }).catch(function (response) {
                vself.lsttitulospagos   = [];
                loader.hide();
            });
        },
        mtdlistarpedidosfaturados(){
            var vself           = this;
            vself.lstpedidos    = [];
            vself.totalfaturado	= 0;            
            let loader      = vself.$loading.show();
            let filtro      = 'and p.stpedido=1 and p.idcliente='+vself.id+' and p.dtfatura between "' + util.InverterData(vself.dtiniinf) + ' 00:00:00" and "' + util.InverterData(vself.dtfiminf) + ' 23:59:59"';
            let parametros  = [
                {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',               valor : 'listagem'},
                {parametro: 'filtro',           valor : filtro},
                {parametro: 'limit',            valor : '99999999999'},
                {parametro: 'offset',           valor : '0'}
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
            retorno.then(function (response) {
                let lstpedtmp = response.data.pedidos;
                for (let i = 0; i < lstpedtmp.length; i++) {
                    lstpedtmp[i].conferido = 0;                    
                }
                vself.lstpedidos        = lstpedtmp;
                //totalizadores
                vself.totalfaturado	    = response.data.totalfaturado;
                loader.hide();											
            }).catch(function (response) {
                vself.lstpedidos        = [];
                loader.hide();
            });            
        },
        mtdlistarnotasemitidas(){
            let vself           = this;
            vself.mostrar   = false;
            vself.lstnotasemitidas    = [];
            this.lstnotasselecionadas = [];

            let loader      = vself.$loading.show();
            let filtro      = 'and nf.situacaonota = 2 and nf.tpdestinatario=0 and nf.iddestinatario='+vself.id+' and nf.dthremissao between "' + util.InverterData(vself.dtiniemissaont) + ' 00:00:00" and "' + util.InverterData(vself.dtfimemissaont) + ' 23:59:59"';
            let parametros  = [
                {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',               valor : 'listagem'},
                {parametro: 'filtro',           valor : filtro},
                {parametro: 'limit',            valor : '99999999999'},
                {parametro: 'offset',           valor : '0'}
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
            retorno.then(function (response) {
                vself.mostrar   = true;
                vself.lstnotasemitidas      = response.data.notas;
                vself.ptotalnotas           = response.data.totalnotas;
                vself.lstdemonstrativoscfop = response.data.demonstrativocfop;
                loader.hide();
            }).catch(function (response) {
                vself.lstnotasemitidas      = [];
                loader.hide();
            });
        },
        mtdexpandirpedidos(indice){
            if (parseInt(this.lstpedidos[indice].conferido) === 1){
                this.lstpedidos[indice].conferido = 0;
            }else{
                this.lstpedidos[indice].conferido = 1;
            }
        },
        mdlexportxml(){
            if(this.lstnotasselecionadas.length == 0){
                this.$toastr.i('É necessário selecionar ao menos uma nota!', 'Informação!');
                return;
            }
            $('#mdexportxml').modal('show');
        },
        mtdsalvarxmls(){
            let vself = this;
            let dadosnotas = [];
            let emaildestinatario = "";
            let nomecliente = "";

            
            if(vself.vemailxml == ''){
                vself.$toastr.i('Atenção! o email deve ser informado');
                return;
            }

            dadosnotas         = vself.lstnotasselecionadas;
            emaildestinatario  = vself.vemailxml;
            nomecliente        = vself.nomecliente;

            $.confirm({
                title: 'Confirmação!',
                content: 'Serão salvos apenas os xmls das notas em situação <span class="badge badge-primary bdg-autorizada">Autorizada</span>, '+
                        'Deseja mesmo continuar?',
                icon: 'fa fa-question-circle',
                escapeKey: true,
                backgroundDismiss: false,
                escapeKey: 'nao',
                type: 'dark',
                typeAnimated: true,
                buttons: {
                    sim: {
                        text: '<u>S</u>im',
                        keys: ['s', 'S'],
                        btnClass: 'btn-blue',
                        action: function () {
                            $('.btn-blue').prop('disabled', true);
                            setTimeout(function(){  
                                let loader  = vself.$loading.show();
                                let parametros = [];
                                parametros      = [
                                    {parametro: 'idclientesac',         valor : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'op',                   valor : 'enviapdfexml'},
                                    {parametro: 'dadosxlmindividual',   valor : JSON.stringify(dadosnotas)},
                                    {parametro: 'emailxml',             valor : emaildestinatario},
                                    {parametro: 'nomeCliente',          valor : nomecliente},
                                ];
                                
                                
                                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                                retorno.then(function (response) {
                                    loader.hide(); 
                                    // if (response.data.inf == 1){
                                    //     //rotina para o download do arquivo
                                    //     window.open(vself.$store.state.configpaths.pathcontrole+response.data.pathdownload, '_blank');
                                    //     $('#mdexportxml').modal('hide');

                                    // }else 
                                    if(response.data.inf == 2){
                                        vself.$toastr.s("Email enviado com sucesso!");
                                        $('#mdexportxml').modal('hide');
                                        $('#mdinformacoescliente').modal('hide');
                                        vself.mostrar    = false;
                                        vself.oplistagem = 0;
                                        vself.lsttitulos = [];
                                        vself.lstnotasemitidas = [];
                                        vself.vrVencidos = 0;
                                        vself.vrAvencer  = 0;
                                        vself.vrJuros    = 0;
                                        vself.vrMulta    = 0;
                                        vself.vrTotal    = 0; 
                                        vself.vdtultimacompra = ''; 
                                    }else{      
                                        let tpret = response.data.inf.substring(0,1);
                                        switch (tpret) {
                                            case 'I':
                                                vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                                                break;
                                            case 'E': 
                                                vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                                break;
                                        }                                                                     
                                    }
                                }).catch(function (response) {
                                    loader.hide();
                                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                });                               
                            }, 200);                                
                        }
                    },
                    nao: {
                        text: '<u>N</u>ão',
                        keys: ['n', 'N'],
                        action: function () {
                        }
                    }
                }
            });
                        
        },
        mtdfechamdlxml(){
            $('#mdexportxml').modal('hide')
        },
        mtdimpressao(){
            let vself   = this;
            let idforma = 0;
            let dados   = []; 
            
            if(vself.lstpedidosselecionados.length == 0){
                vself.$toastr.i('É necessário selecionar um pedido!', 'Informação!');
                return;
            }
            vself.lstpedidosselecionados.forEach(item => {
                dados.push(item.id);
            });

            let filtro  = 'and p.stpedido = 1 and p.idcliente='+ vself.id +' and p.dtemissao between "'+util.InverterData(vself.dtiniinf)+'" and "'+util.InverterData(vself.dtfiminf)+ '" and p.id in ('+dados+')';

            window.open(vself.$store.state.configpaths.pathcontrole+'rtcadpedidosvenda.php?idclientesac='+
                        vself.$store.state.filialpadrao.idcliente+
                        '&op=imprimirlistapedidos'+
                        '&filtro='+filtro+
                        '&situacao='+1+
                        '&dtini='+util.InverterData(vself.dtiniinf)+
                        '&dtfim='+util.InverterData(vself.dtfiminf)+
                        '&idforma='+idforma+
                        '&detitem='+0+
                        '&usuario='+vself.$store.state.usuario.nome+
                        '&gerarexcel='+0, '_blank');	                
        },
    },
    mounted: function(){
        let vself = this;
        $("#mdinformacoescliente").on('shown.bs.modal', function(){
            let retm        = util.pri_ult_diames(new Date, true);
            vself.dtiniinf  = retm.primeirodiames;
            vself.dtfiminf  = retm.ultimodiames;       
            vself.dtiniemissaont  = retm.primeirodiames;
            vself.dtfimemissaont  = retm.ultimodiames;   
            vself.mtdlistartitulosreceber();  
            vself.mtdpegadtultimacompracli();
            vself.mtdselect2_def();         
        });
        $("#mdinformacoescliente").on('hide.bs.modal', function(){
            vself.mostrar    = false;
            vself.oplistagem = 0;
            vself.lsttitulos = [];
            vself.lstnotasemitidas = [];
            vself.lstpedidosselecionados = [];
            vself.vrVencidos = 0;
            vself.vrAvencer  = 0;
            vself.vrJuros    = 0;
            vself.vrMulta    = 0;
            vself.vrTotal    = 0; 
            vself.vdtultimacompra = '';            
        });
        // rotinas exportxmls - guga
        let dataAtual = new Date();
        let mesatual  = dataAtual.getMonth();
        this.anoAtual = dataAtual.getFullYear();
        
        this.anoselect = parseInt(this.anoAtual);
        this.messelect = parseInt(mesatual);


        for (let index = 0; index < 20; index++) {// cria uma lista de anos a partir da data atual - guga
            if(index===0){
                this.anoslista[index] = parseInt(this.anoAtual)
            }else{
                this.anoslista[index] = this.anoslista[index - 1] - 1;
            }
        }
    },
    computed:{

    },
    watch: {
        
    }
}
</script>
<style>
 .img-cliente-inf{
    height: 150px;
    width: 150px;
    border: 1px solid #cccccc;
    border-radius: 10px;    
 }
</style>